import Loader from 'components/Loader';
import useRequest from 'hooks/useRequest';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { consultationStatusEnum } from 'utils/constants';
import { titleCaseIfExists } from 'utils/helper';

const UpdateStatusModal = ({ isOpen, toggle, selectedItem }) => {
  const [notes, setNotes] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');

  const statusOptions = Object.keys(consultationStatusEnum)?.map((e) => ({
    label: titleCaseIfExists(e),
    value: consultationStatusEnum[e],
  }));

  const [updateConsultation, { loading: updateConsultationLoading }] = useRequest({
    onSuccess: () => {
      toggle();
    },
    onError: (err) => {
      toast.error(err?.message?.message || err?.message);
    },
  });

  const [updateConsultationStatus, { loading: updateConsultationStatusLoading }] = useRequest({
    onSuccess: () => {
      toast.success('Consultation Status has been updated.');
      window.location.reload();
    },
    onError: (err) => {
      toast.error(err?.message?.message || err?.message);
    },
  });

  const handleUpdateConsultation = async () => {
    await updateConsultation({
      method: 'PUT',
      url: `/consultation/admin/${selectedItem?.id}`,
      body: {
        notes,
      },
    });
  };

  const handleSave = async () => {
    await handleUpdateConsultation();
    await updateConsultationStatus({
      method: 'PUT',
      url: `/consultation/admin/${selectedItem?.id}/update-status`,
      body: {
        status: selectedStatus,
      },
    });
  };

  useEffect(() => {
    if (!isEmpty(selectedItem)) {
      setNotes(selectedItem?.notes || '');
      setSelectedStatus(selectedItem?.status || '');
    }
  }, [selectedItem]);

  return (
    <>
      <Loader isActive={updateConsultationLoading || updateConsultationStatusLoading} />
      <Modal size="md" centered={true} isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Update Status</ModalHeader>
        <ModalBody className="p-4">
          <FormGroup className="mb-4">
            <Label for="status" className="form-label  ">
              Status
            </Label>
            <Select
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 999 }),
              }}
              options={statusOptions}
              value={!isEmpty(selectedStatus) ? statusOptions?.find((e) => e?.value === selectedStatus) : null}
              onChange={(e) => {
                setSelectedStatus(e?.value);
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label for="notes" className="form-label  ">
              Notes
            </Label>
            <Input
              type="textarea"
              className="form-control"
              id="notes"
              rows="5"
              placeholder="Notes..."
              value={notes}
              onChange={(e) => {
                setNotes(e.target.value);
              }}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button className="me-2" color="primary" onClick={handleSave}>
            Save
          </Button>
          <Button color="light" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default UpdateStatusModal;
